module.exports = __webpack_public_path__ + "img/acqua-palace_acqua-palace__K8A7666.ea282e7c.jpeg";